import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import GameContainer from "./GameContainer/GameContainer";
import { PlayerContextProvider } from "./PlayerContext/PlayerContext";
import { GameContextProvider } from "./GameContext/GameContext";
var queryClient = new QueryClient();
var GameBase = function (_a) {
    var children = _a.children, initialBalance = _a.initialBalance, initialGameResults = _a.initialGameResults, constants = _a.constants;
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(PlayerContextProvider, { children: _jsx(GameContextProvider, { initialBalance: initialBalance, initialGameResults: initialGameResults, constants: constants, children: _jsx(GameContainer, { children: children }) }) }) }));
};
GameBase.displayName = "GameBase";
export default GameBase;
//# sourceMappingURL=GameBase.js.map